class SignupRouting {
  constructor($timeout, $state, $location) {
    this.$timeout = $timeout;
    this.$state = $state;
    this.$location = $location;
  }

  routeSignInPage(posting_data, currentUser) {
    if (posting_data.preserve === true) {
      posting_data.t = currentUser.access_token;

      if (posting_data.job_posting_type === "delivery") {
        console.log("SERV: Routing to post order");
        this.go_to_postorder(posting_data);
      } else {
        console.log("SERV: Routing to post event");
        this.go_to_postevent(posting_data);
      }
    } else {
      console.log("SERV: Routing to onboarding");
      this.go_to_onboarding();
    }
  }

  go_to_onboarding() {
    this.$state.go("onboarding1");
  }

  go_to_postorder(posting_data) {
    this.$timeout(() => {
      this.$state.go("postorder", posting_data);
    }, 300);
  }

  go_to_postevent(posting_data) {
    this.$timeout(() => {
      this.$state.go("postevent", posting_data);
    }, 300);
  }

  routePage() {
    if (this.$location.$$path.indexOf("company") > -1) {
      return 1;
    }
    if (this.$location.$$path.indexOf("jobbler") > -1) {
      return 2;
    }

    return 3;
  }
}

SignupRouting.$inject = ["$timeout", "$state", "$location"];

export default SignupRouting;



// WEBPACK FOOTER //
// ./client/app/scenes/signup/services/routing.js